import { apiService } from '@/services/APIService';

export default {
  getSearchEvents(params) {
    return apiService.get('/public/events/search', params);
  },

  getSearchEventCategories(params) {
    return apiService.get('/event-categories/search', params);
  },
};
